export default "__VITE_ASSET__jdaKWzxDdLISUlRyIgaZpQ__"